import {
  homeLocationErrorFragment,
  warehouseErrorFragment
} from "@saleor/fragments/errors";
import { homeLocationFragment } from "@saleor/fragments/homeLocation";
import { warehouseDetailsFragment } from "@saleor/fragments/warehouses";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  HomeLocationCreate,
  HomeLocationCreateVariables
} from "./types/HomeLocationCreate";
import {
  HomeLocationDelete,
  HomeLocationDeleteVariables
} from "./types/HomeLocationDelete";
import {
  HomeLocationUpdate,
  HomeLocationUpdateVariables
} from "./types/HomeLocationUpdate";
import {
  WarehouseCreate,
  WarehouseCreateVariables
} from "./types/WarehouseCreate";
import {
  WarehouseDelete,
  WarehouseDeleteVariables
} from "./types/WarehouseDelete";
import {
  WarehouseUpdate,
  WarehouseUpdateVariables
} from "./types/WarehouseUpdate";

const deleteWarehouse = gql`
  ${warehouseErrorFragment}
  mutation WarehouseDelete($id: ID!) {
    deleteWarehouse(id: $id) {
      errors: warehouseErrors {
        ...WarehouseErrorFragment
      }
    }
  }
`;
export const useWarehouseDelete = makeMutation<
  WarehouseDelete,
  WarehouseDeleteVariables
>(deleteWarehouse);

const createWarehouse = gql`
  ${warehouseDetailsFragment}
  ${warehouseErrorFragment}
  mutation WarehouseCreate($input: WarehouseCreateInput!) {
    createWarehouse(input: $input) {
      errors: warehouseErrors {
        ...WarehouseErrorFragment
      }
      warehouse {
        ...WarehouseDetailsFragment
      }
    }
  }
`;

export const useWarehouseCreate = makeMutation<
  WarehouseCreate,
  WarehouseCreateVariables
>(createWarehouse);

const updateWarehouse = gql`
  ${warehouseDetailsFragment}
  ${warehouseErrorFragment}
  mutation WarehouseUpdate($id: ID!, $input: WarehouseUpdateInput!) {
    updateWarehouse(id: $id, input: $input) {
      errors: warehouseErrors {
        ...WarehouseErrorFragment
      }
      warehouse {
        ...WarehouseDetailsFragment
      }
    }
  }
`;
export const useWarehouseUpdate = makeMutation<
  WarehouseUpdate,
  WarehouseUpdateVariables
>(updateWarehouse);

const createHomeLocation = gql`
  ${homeLocationFragment}
  ${homeLocationErrorFragment}
  mutation HomeLocationCreate(
    $homeLocationName: String!
    $longitude: Decimal!
    $latitude: Decimal!
    $remarks: String
    $warehouseId: ID!
  ) {
    createHomeLocation(
      homeLocationName: $homeLocationName
      longitude: $longitude
      latitude: $latitude
      remarks: $remarks
      warehouseId: $warehouseId
    ) {
      errors: homeLocationErrors {
        ...HomeLocationErrorFragment
      }
      homeLocation {
        ...HomeLocationFragment
      }
    }
  }
`;

export const useHomeLocationCreate = makeMutation<
  HomeLocationCreate,
  HomeLocationCreateVariables
>(createHomeLocation);

const deleteHomeLocation = gql`
  ${homeLocationFragment}
  ${homeLocationErrorFragment}
  mutation HomeLocationDelete($homeLocationId: ID!) {
    deleteHomeLocation(homeLocationId: $homeLocationId) {
      errors: homeLocationErrors {
        ...HomeLocationErrorFragment
      }
      homeLocation {
        ...HomeLocationFragment
      }
    }
  }
`;

export const useHomeLocationDelete = makeMutation<
  HomeLocationDelete,
  HomeLocationDeleteVariables
>(deleteHomeLocation);

const updateHomeLocation = gql`
  ${homeLocationFragment}
  ${homeLocationErrorFragment}
  mutation HomeLocationUpdate(
    $homeLocationId: ID!
    $homeLocationName: String!
    $longitude: Decimal!
    $latitude: Decimal!
    $remarks: String
  ) {
    updateHomeLocation(
      homeLocationId: $homeLocationId
      homeLocationName: $homeLocationName
      longitude: $longitude
      latitude: $latitude
      remarks: $remarks
    ) {
      errors: homeLocationErrors {
        ...HomeLocationErrorFragment
      }
      homeLocation {
        ...HomeLocationFragment
      }
    }
  }
`;

export const useHomeLocationUpdate = makeMutation<
  HomeLocationUpdate,
  HomeLocationUpdateVariables
>(updateHomeLocation);
